import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';

/**
 * Presentational status for one S3 config. Unlike the SES email badge there is no live connection
 * probe — an S3 config has no cheap no-op check — so this reflects the stored {@code active} flag.
 */
export function S3ConfigStatusBadge({ active }: { readonly active: boolean }): ReactElement {
  const { t } = useTranslation();
  return active ? (
    <Badge variant="secondary" title={t('routes.admin.s3.status.activeTitle')}>
      {t('routes.admin.s3.status.active')}
    </Badge>
  ) : (
    <Badge variant="outline" title={t('routes.admin.s3.status.inactiveTitle')}>
      {t('routes.admin.s3.status.inactive')}
    </Badge>
  );
}
